import * as React from "react"
import { ExclamationCircleIcon } from "@heroicons/react/20/solid"
import classNames from "classnames"

export default function Input({
  id,
  label,
  name,
  type,
  error,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  className,
  inputClassName,
  testid,
  autoComplete,
}: {
  id?: string
  label?: string
  name: string
  type: string
  placeholder?: string
  error: string | null
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  disabled: boolean
  className?: string
  inputClassName?: string
  testid?: string
  autoComplete?: string
}) {
  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className="block mb-2 text-sm font-medium leading-6 text-gray-900 dark:text-gray-50"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id || name}
          name={name}
          type={type}
          autoComplete={autoComplete || name}
          placeholder={placeholder}
          className={classNames(
            ` block w-full rounded-md shadow-sm  border-0 py-1.5 ring-1 ring-inset focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200 dark:bg-gray-800 dark:text-gray-50 dark:disabled:bg-gray-700 dark:disabled:ring-gray-500`,
            {
              "text-gray-900  ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400  focus:ring-indigo-600 ":
                !error,
              "text-red-900  ring-red-300 placeholder:text-red-300    focus:ring-red-500 ":
                error,
            },
            inputClassName
          )}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          disabled={disabled}
          value={value}
          data-testid={testid}
        />
        {error && (
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <ExclamationCircleIcon
              className="h-5 w-5 text-red-500"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600" data-testid={`${name}-error`}>
          {error}
        </p>
      )}
    </div>
  )
}
